(() => {
  const menuSelector = 'header-menu > details, header-drawer > details';
  const searchSelector = 'details-modal.header__search';

  const closePredictions = (modal) => {
    modal.querySelectorAll('predictive-search').forEach((search) => search.close?.());
  };

  const closeSearchModals = (except = null) => {
    let closed = false;
    document.querySelectorAll(searchSelector).forEach((modal) => {
      if (modal === except || !modal.querySelector('details')?.open) return;
      closePredictions(modal);
      modal.close(false);
      modal.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      if (modal.contains(document.activeElement)) document.activeElement.blur();
      closed = true;
    });
    return closed;
  };

  const closeMenu = (details) => {
    const owner = details.parentElement;
    const isDrawer = owner.matches('header-drawer');
    const wasOpen = details.open || details.classList.contains('menu-opening');
    const hadFocus = details.contains(document.activeElement);

    // The desktop component owns its hover timer. Never leave that timer running.
    if (!isDrawer && typeof owner.close === 'function') owner.close();
    details.removeAttribute('open');
    details.classList.remove('menu-opening', 'submenu-open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    details.querySelectorAll('details').forEach((nested) => {
      nested.removeAttribute('open');
      nested.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });
    details.querySelectorAll('.menu-opening, .submenu-open').forEach((element) => {
      element.classList.remove('menu-opening', 'submenu-open');
    });

    if (isDrawer && wasOpen) {
      (owner.header || owner.closest('.section-header'))?.classList.remove('menu-open');
      if (owner.onResize) window.removeEventListener('resize', owner.onResize);
      const lock = `overflow-hidden-${owner.dataset.breakpoint}`;
      document.documentElement.classList.remove(lock);
      document.body.classList.remove(lock);
      if (hadFocus) removeTrapFocus();
    }
  };

  const closeAllMenus = (except = null) => {
    document.querySelectorAll(menuSelector).forEach((details) => {
      if (details !== except) closeMenu(details);
    });
    // Do not remove generic overflow-hidden here: cart/search/product dialogs own it.
  };

  const closeCart = () => {
    const cart = document.querySelector('cart-drawer');
    if (cart?.classList.contains('active') || cart?.openTimer) cart.close(false);
  };

  // Capture runs BEFORE the new panel installs a focus trap or a scroll lock.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const summary = target.closest('summary');
    const details = summary?.parentElement;
    if (details?.matches(menuSelector)) {
      closeSearchModals();
      closeCart();
      closeAllMenus(details);
      return;
    }
    if (details?.parentElement.matches(searchSelector)) {
      closeAllMenus();
      closeCart();
      closeSearchModals(details.parentElement);
      return;
    }
    if (target.closest('shopify-account')) {
      closeAllMenus();
      closeSearchModals();
      return;
    }
    const link = target.closest('header a[href], .menu-drawer a[href], .mega-menu__content a[href]');
    if (link && !link.matches('#cart-icon-bubble') && !link.closest(searchSelector)) closeAllMenus();
  }, true);

  // Includes carts opened by Add to cart, not just by the header icon.
  document.addEventListener('darchi:cart-opening', () => {
    closeAllMenus();
    closeSearchModals();
  });

  // Shopify's account component emits a composed, non-bubbling open event.
  document.addEventListener('open', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('shopify-account')) return;
    closeAllMenus();
    closeSearchModals();
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('header-drawer > details[open]').forEach((details) => {
      if (!details.parentElement.contains(event.target)) closeMenu(details);
    });
  }, true);

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (details.parentElement.matches(searchSelector)) {
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
      if (!details.open) closePredictions(details.parentElement);
      return;
    }
    if (!details.matches(menuSelector)) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    if (details.open) {
      const closedSearch = closeSearchModals();
      closeAllMenus(details);
      if (closedSearch && details.parentElement.matches('header-drawer')) {
        trapFocus(details, details.querySelector(':scope > summary'));
      }
    }
    queueMicrotask(() => {
      document.querySelectorAll('.header-wrapper').forEach((header) => {
        header.preventHide = !!header.querySelector('header-menu > details[open]');
      });
    });
  }, true);

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll(menuSelector).forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (details.open && summary && !summary.getClientRects().length) closeMenu(details);
      });
      document.querySelectorAll(searchSelector).forEach((modal) => {
        const summary = modal.querySelector('summary');
        if (modal.querySelector('details')?.open && summary && !summary.getClientRects().length) {
          closePredictions(modal);
          modal.close(false);
        }
      });
    }, 60);
  }, { passive: true });

  window.addEventListener('pageshow', () => {
    closeAllMenus();
    closeSearchModals();
    closeCart();
  });
})();
